import type { Theme } from "@mui/material";

const MuiChip = (theme: Theme) => ({
  styleOverrides: {
    root: {
      "&.MuiChip-outlined": { color: theme.palette.text.primary },
      "&.MuiChip-outlined.MuiChip-colorPrimary": { color: theme.palette.text.primary },
      "&.MuiChip-outlined.MuiChip-colorSecondary": { color: theme.palette.text.primary },
      "&.MuiChip-outlinedSuccess": { color: theme.palette.text.primary },
      "&.MuiChip-outlinedError": { color: theme.palette.text.primary },
      "&.MuiChip-outlinedInfo": { color: theme.palette.text.primary },
      "&.MuiChip-outlinedWarning": { color: theme.palette.text.primary },
    },
  },
});
export default MuiChip;
